import type { Metric } from 'web-vitals';

export type WebVitalMetric = Metric;

export type WebVitalReporter = (metric: Metric) => void;

const defaultReporter: WebVitalReporter = (metric) => {
  if (import.meta.env.DEV) {
    console.log(`[Web Vitals] ${metric.name}: ${metric.value.toFixed(1)} (${metric.rating})`);
  }
};

export async function initWebVitals(reporter?: WebVitalReporter): Promise<void> {
  const { onLCP, onINP, onCLS, onFCP, onTTFB } = await import('web-vitals');
  const report = reporter ?? defaultReporter;
  onLCP(report);
  onINP(report);
  onCLS(report);
  onFCP(report);
  onTTFB(report);
}
